import { useState, useEffect, useRef } from "react";
import UILoader from "@components/ui-loader";
import {
  ConfirmAction,
  ConfirmRegistrationError,
  ConfirmRegistrationSuccess,
} from "@pageUtils/message-alert";
import "@styles/base/pages/page-auth.scss";
import MySwalBlockUi from "@pageUtils/block-ui";
import { toThaiLocalISOString } from "../../../../../utility/Utils";

import {Col, Form, Input, FormGroup, Button, Label} from "reactstrap";

import "@styles/react/libs/editor/editor.scss";
import "@styles/base/plugins/forms/form-quill-editor.scss";
import "@styles/react/libs/react-select/_react-select.scss";
import "@styles/base/pages/page-blog.scss";
import "@styles/react/libs/flatpickr/flatpickr.scss";

import Flatpickr from "react-flatpickr";
import { Thai } from "flatpickr/dist/l10n/th.js";

import { ArrowLeft, Edit, File, Save, X } from "react-feather";
import classnames from "classnames";
import { Link } from "react-router-dom";
import axios from "axios";
import initialConfig from "@configs/initialConfig";
import { useForm } from "react-hook-form";

const PaymentReceipt = (props) => {
  const {
    data,
    payment,
    transactionCourseUser,
    transactionPaymentProofs,
    transactionCourseUserAddress,
    getCourseDetail,
    courseId,
    dispatch,
    stepper,
    receiptDate,
    setReceiptDate,
    address1,
    setAddress1,
    address2,
    setAddress2,
    receiptNameFlag,
    setReceiptNameFlag,
  } = props;

  const divError = {
    border: "1px solid",
    borderColor: "red",
    borderRadius: "5px",
  };
  const { register, errors, handleSubmit, trigger } = useForm();
  const [disabled, setDisabled] = useState("disabled");
  const [receiptDateClassName, setReceiptDateClassName] = useState("");
  const [address2ClassName, setAddress2ClassName] = useState("");
  const [address1ClassName, setAddress1ClassName] = useState("");

  function setDisabledFunction() {
    setDisabled(disabled === "disabled" ? "" : "disabled");
    setReceiptDate(
      transactionCourseUserAddress && transactionCourseUserAddress.receiptDate
        ? new Date(transactionCourseUserAddress.receiptDate)
        : null
    );
    setAddress1(
      transactionCourseUserAddress && transactionCourseUserAddress.address1
        ? transactionCourseUserAddress.address1
        : null
    );
    setAddress2(
      transactionCourseUserAddress && transactionCourseUserAddress.address2
        ? transactionCourseUserAddress.address2
        : null
    );
  }

  function getDisableDate() {
    const result = disabled === "disabled";
    return result;
  }

  function setReceiptDateFunction(value) {
    setReceiptDate(value);
    setReceiptDateClassName("");
  }

  function setAddress1Function(value) {
    setAddress1(value);
    setAddress1ClassName("");
  }

  function setAddress2Function(value) {
    setAddress2(value);
    setAddress2ClassName("");
  }

  useEffect(() => {
    setReceiptDate(
      transactionCourseUserAddress && transactionCourseUserAddress.receiptDate
        ? new Date(transactionCourseUserAddress.receiptDate)
        : null
    );
    setAddress1(
      transactionCourseUserAddress && transactionCourseUserAddress.address1
        ? transactionCourseUserAddress.address1
        : null
    );
    setAddress2(
      transactionCourseUserAddress && transactionCourseUserAddress.address2
        ? transactionCourseUserAddress.address2
        : null
    );
    setReceiptNameFlag(
        transactionCourseUserAddress && transactionCourseUserAddress.receiptNameFlag
            ? transactionCourseUserAddress.receiptNameFlag
            : null
    );
  }, []);

  const saveReceipt = () => {
    const mySwal = MySwalBlockUi();
    axios
      .post(initialConfig.ipServer.concat("/api/payment/save/receipt"), {
        transactionCourseUserAddressId: transactionCourseUserAddress.id,
        receiptDate: toThaiLocalISOString(receiptDate),
        address1: address1,
        address2: address2,
        receiptNameFlag: receiptNameFlag
      })
      .then((res) => {
        // setBlock(false);
        mySwal.close();

        if (res.data.statusCode === "0" || res.data.statusCode === 0) {
          ConfirmRegistrationSuccess({
            callbackFunction: null,
            title: "ทำรายการสำเร็จ",
            text: res.data.statusDesc,
          });
          setDisabled("disabled");
          dispatch({
            type: "SAVE_RECEIPT",
            data: res.data,
          });
        } else {
          ConfirmRegistrationError({
            callbackFunction: null,
            title: "ไม่สามารถทำรายการได้",
            text: res.data.statusDesc,
          });
        }
      });
  };

  const printLink = () => {
    return (
      "/receipt/" +
      (transactionCourseUser && transactionCourseUser.courseId
        ? transactionCourseUser.courseId
        : "") +
      "/" +
      (transactionCourseUser && transactionCourseUser.userId
        ? transactionCourseUser.userId
        : "") +
      "/" +
      (transactionCourseUser && transactionCourseUser.id
        ? transactionCourseUser.id
        : "")
    );
  };

  const actionClick = (e) => {
    ConfirmAction({
      callbackFunction: saveReceipt,
      title: "ยืนยันทำรายการ",
      text: "",
    });
  };

  const saveReceiptV2 = () => {
    const mySwal = MySwalBlockUi();
    axios
      .post(initialConfig.ipServer.concat("/api/payment/reset/data/receipt"), {
        transactionCourseUserAddressId: transactionCourseUserAddress.id,
      })
      .then((res) => {
        // setBlock(false);
        mySwal.close();

        if (res.data.statusCode === "0" || res.data.statusCode === 0) {
          ConfirmRegistrationSuccess({
            callbackFunction: null,
            title: "ทำรายการสำเร็จ",
            text: res.data.statusDesc,
          });

          setDisabled("disabled");

          dispatch({
            type: "SAVE_RECEIPT",
            data: res.data,
          });

          setReceiptDate(
            res.data.transactionCourseUserAddress &&
              res.data.transactionCourseUserAddress.receiptDate
              ? new Date(res.data.transactionCourseUserAddress.receiptDate)
              : null
          );
          setAddress1(
            res.data.transactionCourseUserAddress &&
              res.data.transactionCourseUserAddress.address1
              ? res.data.transactionCourseUserAddress.address1
              : null
          );
          setAddress2(
            res.data.transactionCourseUserAddress &&
              res.data.transactionCourseUserAddress.address2
              ? res.data.transactionCourseUserAddress.address2
              : null
          );
          setReceiptNameFlag(
              res.data.transactionCourseUserAddress &&
              res.data.transactionCourseUserAddress.receiptNameFlag
                  ? res.data.transactionCourseUserAddress.receiptNameFlag
                  : null
          );
        } else {
          ConfirmRegistrationError({
            callbackFunction: null,
            title: "ไม่สามารถทำรายการได้",
            text: res.data.statusDesc,
          });
        }
      });
  };

  const actionV2Click = (e) => {
    ConfirmAction({
      callbackFunction: saveReceiptV2,
      title: "ยืนยันทำรายการ",
      text: "",
    });
  };

  const onSubmit = () => {
    let foundError = false;
    if (!receiptDate) {
      foundError = true;
      setReceiptDateClassName("is-invalid");
    } else {
      setReceiptDateClassName("");
    }

    if (!address1) {
      foundError = true;
      setAddress1ClassName("is-invalid");
    } else {
      setAddress1ClassName("");
    }

    if (!address2) {
      foundError = true;
      setAddress2ClassName("is-invalid");
    } else {
      setAddress2ClassName("");
    }

    if (foundError) {
    } else {
      actionClick();
    }
  };

  return (
    <div className="blog-edit-wrapper">
      <Col sm="12">
        <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
          <Col md="12">
            <FormGroup className="mb-2">
              <h4>หลักสูตร : {data.courseName}</h4>
            </FormGroup>
          </Col>
          <Col md="12">
            <FormGroup className="mb-2">
              <span>
                ใบเสร็จเลขที่ :{" "}
                {transactionCourseUserAddress
                  ? transactionCourseUserAddress.receiptNo
                  : "-"}{" "}
              </span>
            </FormGroup>
          </Col>
          <Col md="12">
            <FormGroup className="mb-2">
              <span>
                ค่าธรรมเนียนหลักสูตร :{" "}
                {transactionCourseUserAddress
                  ? transactionCourseUserAddress.bath1
                  : "-"}{" "}
                บาท
              </span>
            </FormGroup>
          </Col>
          <Col md="12">
            <FormGroup className="mb-2">
              <span>
                ชื่อบนใบเสร็จ :
              </span>
              <Input
                  type="select"
                  id="receiptNameFlag"
                  value={receiptNameFlag}
                  onChange={(e) =>
                      setReceiptNameFlag(e.target.value)
                  }
                  disabled={disabled}
              >
                <option value="A">{transactionCourseUserAddress ? transactionCourseUserAddress.fullname : ""}</option>
                <option value="B">{transactionCourseUserAddress ? ""+transactionCourseUserAddress.universityName : ""}</option>
                <option value="C">{transactionCourseUserAddress ? ""+transactionCourseUserAddress.facultyName : ""} {transactionCourseUserAddress ? "     "+transactionCourseUserAddress.universityName : ""}</option>
              </Input>
            </FormGroup>
          </Col>
          <Col md="4">
            <FormGroup className="mb-2">
              <span>วันที่บนใบเสร็จ{" : "}</span>
              <Flatpickr
                className={
                  "flatpickr-input form-control " + receiptDateClassName
                }
                value={receiptDate}
                onChange={(date) => setReceiptDateFunction(date[0])}
                id="receiptDate"
                disabled={disabled}
                options={{
                  disableMobile: "true",
                  dateFormat: "d/m/Y",
                  locale: Thai,
                  isBuddhist: "true",
                }}
                style={
                  disabled === "disabled"
                    ? { backgroundColor: "#efefef" }
                    : null
                }
              />
            </FormGroup>
          </Col>
          <Col md="12">
            <FormGroup className="mb-2">
              <span>ที่อยู่บนใบเสร็จ{" : "}</span>
              <Input
                type="text"
                className={address1ClassName}
                value={address1}
                maxLength="255"
                onChange={(e) => setAddress1Function(e.target.value)}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
          <Col md="12">
            <FormGroup className="mb-2">
              <Input
                type="text"
                value={address2}
                className={address2ClassName}
                maxLength="255"
                onChange={(e) => setAddress2Function(e.target.value)}
                disabled={disabled}
              />
            </FormGroup>
          </Col>
          <Col className="mt-50">
            <Button
              color="outline-primary"
              className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
              onClick={() => stepper.previous()}
            >
              <ArrowLeft size={14} className={classnames("mr-50")} />
              <span>กลับ</span>
            </Button>
            {transactionCourseUser &&
            (transactionCourseUser.status === "PAYMENT_SUCCESS" ||
              transactionCourseUser.status === "WAIT_ADMIN_APPROVE") ? (
              <Link
                className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0 btn btn-outline-primary"
                to={printLink()}
                target="_blank"
              >
                <File className="mr-50" size={14} />
                พิมพ์ใบเสร็จ
              </Link>
            ) : null}
            {transactionCourseUser &&
            (transactionCourseUser.status === "PAYMENT_SUCCESS" ||
              transactionCourseUser.status === "WAIT_ADMIN_APPROVE") ? (
              <Button
                color="outline-primary"
                className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
                onClick={() => actionV2Click()}
              >
                <File className="mr-50" size={14} />
                ปรับข้อมูลบนใบเสร็จ (หากท่านมีการแก้ไขข้อมูลส่วนตัว)
              </Button>
            ) : null}
            {disabled !== "disabled" ? (
              <Button
                color="outline-primary"
                className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
                onClick={() => setDisabledFunction()}
              >
                <X size={14} className={classnames("mr-50")} />
                <span>ยกเลิก</span>
              </Button>
            ) : null}
            {disabled === "disabled" ? (
              <Button
                color="outline-primary"
                className="btn-wishlist mr-0 mr-sm-1 mb-1 mb-sm-0"
                onClick={() =>
                  setDisabled(disabled === "disabled" ? "" : "disabled")
                }
              >
                <Edit size={14} className={classnames("mr-50")} />
                <span>แก้ไข (ชื่อบนใบเสร็จ / วันที่ / ที่อยู่บนใบเสร็จ)</span>
              </Button>
            ) : (
              <Button.Ripple
                color="primary"
                className="mr-1"
                type="submit"
                //onClick={actionClick}
              >
                <Save size={14} className={classnames("mr-50")} />
                บันทึก
              </Button.Ripple>
            )}
          </Col>
        </Form>
      </Col>
    </div>
  );
};

export default PaymentReceipt;
